import React from 'react';
import { sendCardInfor } from '../../store/actions/cardAction';
import { connect } from 'react-redux';
import { getAllTaxesCreaSP } from '../../store/actions/taxeAction';
import SweetAlert from 'react-bootstrap-sweetalert';
import './CardScreen.scss';
import { Row, Col } from 'reactstrap';
import Radio from '@material-ui/core/Radio';
import redcircle from '../../assets/images/redcircle.png';
import visa from '../../assets/images/visa.png';
import hipercard from '../../assets/images/hipercard.png';
import backet from '../../assets/images/backet.png';
import elo from '../../assets/images/elo.png';
import { Checkbox } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import gitLoading from '../../assets/images/loader.gif';
import credit_front from '../../assets/images/credit_front.png';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import checkicon from '../../assets/images/check.png';
import config from '../../global/config';
const qs = require('query-string');

class CardScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,
      paymentType: 'credit',
      curInstallment: null,
      curInstallmentIndex: -1,
      isAcceptPolicy: false,
      isFormValid: false,
      // cardNumber: "1234567890123456",
      cardNumber: '',
      expireDate: '',
      cvvCode: '',
      cpf: '',
      card_name: '',
      // cvvCode: "997",
      isLoading: true,
      alertMsg: '',
      alertType: 'success',
      orderNumber: '',
      totalOrderAmount: 0,
      orderguid: '',
      linkCB: 'https:h.online-metrix.net/fp/tags?org_id=k8vif92e&session_id=',
      linkCB2:
        'https:h.online-metrix.net/fp/tags.js?org_id=k8vif92e&session_id=',
      ip: '',
      fingerprintSessionId: 0,
    };
  }

  componentDidMount() {
    let order_guid = this.props.match.params.post_id;
    let order_number = this.props.match.params.order_number;

    let fingerprintSessionId = Math.random();
    fingerprintSessionId = fingerprintSessionId.toString().replace('0.', '');
    this.setState({ fingerprintSessionId: fingerprintSessionId });
    let linkCB = this.state.linkCB + 'giropagamentos_br' + fingerprintSessionId;
    let linkCB2 =
      this.state.linkCB2 + 'giropagamentos_br' + fingerprintSessionId;
    this.setState({ linkCB: linkCB });
    this.setState({ linkCB2: linkCB2 });

    this.getIP();

    fetch(config.apiServer + '/api/creasp/GetOrderCheckout/' + order_guid)
      .then((id) => id.json())
      .then((value) => {
        this.props
          .getAllTaxesCreaSP([value.valorCarrinho, 1361])
          .then((res) => {
            //console.log(res)
            this.setState({
              isLoading: false,
              orderNumber: order_number,
              orderguid: order_guid,
              totalOrderAmount: value.valorCarrinho,
            });
          });
      })
      .catch((error) => {
        this.props.getAllTaxesCreaSP(0).then((res) => {
          //console.log(res)
          this.setState({
            isLoading: false,
            orderNumber: order_number,
            orderguid: order_guid,
          });
        });
      });
  }

  showToast = (msg, type) => {
    this.setState({ showAlert: true, alertMsg: msg, alertType: type });
  };

  onConfirm = () => {
    this.setState({ showAlert: false });
  };

  onCancel = () => {
    this.setState({ showAlert: false });
  };

  setCurInstallment = (curInstallment, curInstallmentIndex) => {
    this.setState({ curInstallment, curInstallmentIndex });
  };

  async getIP() {
    await fetch('https://api.ipify.org?format=json')
      .then((id) => id.json())
      .then((response) => {
        this.setState({ ip: response.ip });
      });
  }

  onSubmit = () => {
    let { cardNumber } = this.state;
    let { cvvCode } = this.state;
    let { card_name } = this.state;
    let { cpf } = this.state;
    let paymentMethod = this.state.paymentType === 'debit' ? 1 : 2;
    let cardRegEx = new RegExp(/^[0-9]{16}$/g);
    let codeRegEx = new RegExp(/^[0-9]{3}$/g);

    let strs = this.state.expireDate.split('/');
    //console.log(this.state.paymentType)
    if (
      this.state.curInstallment === null &&
      this.state.paymentType != 'debit'
    ) {
      this.showToast('Por favor, selecione a parcela', 'warning');
      return;
    }
    if (card_name === '') {
      this.showToast('Por favor, informar nome impresso no cartão', 'warning');
      return;
    }
    if (cpf === '') {
      this.showToast('Por favor, informar CPF do titular do cartão', 'warning');
      return;
    }

    this.setState({ isLoading: true });

    if (cardRegEx.test(cardNumber)) {
      if (strs.length === 2) {
        let taxeInfo = this.props.taxes.taxeInfo;
        let expireMonth = strs[0];
        let expireYear = strs[1];
        if (Math.floor(expireMonth < 13) && Math.floor(expireYear) > 19) {
          if (codeRegEx.test(cvvCode)) {
            this.setState({ isLoading: true });
            let today = new Date();
            const data = {
              idOrder:
                today.getDay() +
                today.getHours() +
                today.getMinutes() +
                today.getSeconds(),
              //'orderNumber': today.getDay() + today.getHours() + today.getMinutes() + today.getSeconds(),
              //'customerOrderNumber': today.getDay() + today.getHours() + today.getMinutes() + today.getSeconds(),
              orderNumber: this.state.orderNumber,
              customerOrderNumber: this.state.orderNumber,
              paymentMethod: paymentMethod,
              totalOrder: this.state.totalOrderAmount,
              installments: this.state.curInstallment
                ? this.state.curInstallment.month
                : '1',
              installmentsValue: this.state.curInstallment
                ? this.state.curInstallment.installmentValue
                : this.state.totalOrderAmount,
              fingerprintSessionId: this.state.fingerprintSessionId,
              ip: this.state.ip,
              cardData: {
                idCard: '',
                cardNumber: cardNumber,
                CardName: card_name,
                CpfNumber: cpf,
                monthValid: expireMonth,
                yearExpiration: expireYear,
                cvvCode: cvvCode,
              },
              nsu: '',
            };
            //console.log('dados')
            //console.log(data)
            this.props.sendCardInfor(data).then((res) => {
              if (
                res.indexOf('Error') === -1 &&
                res.indexOf('Carrinho') === -1
              ) {
                setTimeout(() => {
                  //se tirar a barra, complementa a url, se colocar a barra, refaz o path da rota.
                  this.props.history.push(
                    '/receipt/' +
                      res.split('|')[0] +
                      '/' +
                      res.split('|')[1]
                  );
                }, 1000);
              } else {
                if (res === 'Error: Falha na comunicacao') {
                  this.showToast('Falha na comunicação com o CREA', 'warning');
                  this.setState({ isLoading: false });
                } else if (
                  res.indexOf('Carrinho finalizado') === -1 &&
                  res.indexOf('Carrinho não encontrado') === -1
                ) {
                  this.showToast(
                    'Erro ao processar pagamento, repita a operação',
                    'warning'
                  );
                  this.setState({ isLoading: false });
                } else {
                  if (res.indexOf('Carrinho finalizado') === -1) {
                    this.showToast('Carrinho não encontrado', 'warning');
                    this.setState({ isLoading: false });
                  } else if (res.indexOf('Falha na comunica') === -1) {
                    this.showToast(
                      'Falha na comunicação com o CREA',
                      'warning'
                    );
                    this.setState({ isLoading: false });
                  } else {
                    this.showToast('Carrinho finalizado', 'warning');
                    this.setState({ isLoading: false });
                  }
                }
              }
            });
          } else {
            this.showToast('CVV inválido', 'warning');
            return;
          }
        } else {
          this.showToast('Data de validade inválida', 'warning');
          return;
        }
      } else {
        this.showToast('Data de validade inválida', 'warning');
        return;
      }
    } else {
      this.showToast('Número do cartão inválido', 'warning');
      return;
    }
  };

  validateNumericInput(e) {
    if (/^\d+$/.test(e.toString())) {
      return true;
    } else {
      return false;
    }
  }

  onHandleChange = (e, field) => {
    let val = e.target.value;
    if (
      field === 'cvvCode' ||
      field === 'cardNumber' ||
      field === 'expireDate' ||
      field === 'cpf'
    ) {
      if (this.validateNumericInput(e.target.value)) {
        this.setState({ [field]: val }, () => {});
      } else {
        if (e.target.value === '') {
          this.setState({ [field]: val }, () => {});
        }
      }
    } else {
      this.setState({ [field]: val }, () => {});
    }

    if (field === 'expireDate') {
      if (e.target.value.length === 4) {
        if (e.target.value.indexOf('/') > -1) {
          //console.log('here')
          val = e.target.value.replace('/', '');
          this.setState({ [field]: val }, () => {});
        } else {
          val =
            e.target.value.toString().substring(0, 2) +
            '/' +
            e.target.value.toString().substring(2, 4);
          this.setState({ [field]: val }, () => {});
        }
      }
    }
  };
  render() {
    let taxeInfo = this.props.taxes.taxeInfo;
    let installments1,
      installments2 = [];
    if (taxeInfo.installments) {
      installments1 = this.props.taxes.taxeInfo.installments.slice(0, 6);
      installments2 = this.props.taxes.taxeInfo.installments.slice(6);
    }
    let { isAcceptPolicy, isFormValid, isLoading } = this.state;
    return (
      <>
        <script type="text/javascript" src={this.state.linkCB2}>
          <iframe
            style={{
              width: '100px',
              height: '100px',
              border: '0',
              position: 'absolute',
              top: '-5000px',
            }}
            src={this.state.linkCB}
            title="d-pa"
          ></iframe>
        </script>

        <div className="main-area" id="main-area">
          <div className="main-section">
            <h4
              style={{
                fontWeight: 'bold',
                paddingLeft: '10px',
                paddingBottom: '30px',
              }}
            >
              Forma de Pagamento:
            </h4>

            <Row>
              {this.state.paymentType === 'credit' ? (
                <Col
                  sm={3}
                  xs={12}
                  className={'p-0 '}
                  style={{ marginBottom: -20 }}
                >
                  <label style={{ display: 'inline' }}>
                    <Radio
                      color="primary"
                      onClick={() => this.setState({ paymentType: 'credit' })}
                      checked={this.state.paymentType === 'credit'}
                    ></Radio>
                    Crédito
                  </label>
                  {/* <label style={{ display: 'inline' }}>
                                            <Radio
                                                color="primary"
                                                onClick={() => this.setState({ paymentType: "debit" })}
                                                checked={this.state.paymentType === "debit"}
                                            ></Radio>
                                            Débito
                                        </label> */}
                  {taxeInfo &&
                    taxeInfo.installments &&
                    installments1.map((item, key) => (
                      <div
                        key={key}
                        className={
                          'check-area ' +
                          (key === this.state.curInstallmentIndex
                            ? 'active'
                            : '')
                        }
                        onClick={() => this.setCurInstallment(item, key)}
                      >
                        <Radio
                          color="primary"
                          checked={key === this.state.curInstallmentIndex}
                        ></Radio>
                        <div className="check-text">
                          <h6>
                            {item.month} X{' '}
                            {item.installmentValue.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </h6>
                        </div>
                      </div>
                    ))}
                </Col>
              ) : (
                <Col
                  sm={3}
                  xs={12}
                  className="p-0"
                  style={{ marginBottom: -20 }}
                >
                  <label style={{ display: 'inline' }}>
                    <Radio
                      color="primary"
                      onClick={() => this.setState({ paymentType: 'credit' })}
                      checked={this.state.paymentType === 'credit'}
                    ></Radio>
                    Crédito
                  </label>
                  {/* <label style={{ display: 'inline' }}>
                                                <Radio
                                                    color="primary"
                                                    onClick={() => this.setState({ paymentType: "debit" })}
                                                    checked={this.state.paymentType === "debit"}
                                                ></Radio>
                                                Débito
                                            </label> */}
                  <div className="check-area">
                    <Radio color="primary" checked={true}></Radio>
                    <div className="check-text">
                      <h6>
                        à vista R${' '}
                        {taxeInfo
                          ? taxeInfo.debitValue.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })
                          : ''}
                      </h6>
                    </div>
                  </div>
                </Col>
              )}
              {this.state.paymentType === 'credit' && (
                <Col sm={3} xs={12} className="p-0">
                  <label className="blank_label"></label>
                  {taxeInfo &&
                    taxeInfo.installments &&
                    installments2.map((item, key) => (
                      <div
                        key={key}
                        className={
                          'check-area ' +
                          (key + 6 === this.state.curInstallmentIndex
                            ? 'active'
                            : '')
                        }
                        onClick={() => this.setCurInstallment(item, key + 6)}
                      >
                        <Radio
                          color="primary"
                          checked={key + 6 === this.state.curInstallmentIndex}
                        ></Radio>
                        <div className="check-text">
                          <h6>
                            {item.month} X{' '}
                            {item.installmentValue.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </h6>
                        </div>
                      </div>
                    ))}
                </Col>
              )}

              <Col sm={6} xs={12}>
                <div className="card-detail">
                  <h5 style={{ fontWeight: 'bold' }}>
                    Preencher os dados do cartão:
                  </h5>
                  <div className="card-type-img padding-top-20">
                    <h5 style={{ fontWeight: 'bold' }}>Cartão do Crédito:</h5>
                    <div className="img-area">
                      <img src={redcircle} alt=""></img>
                      <img src={visa} alt="visa"></img>
                      <img src={hipercard} alt="hipercard"></img>
                      <img src={elo} alt="elo"></img>
                    </div>
                  </div>
                  <div
                    className="card-number padding-top-20"
                    style={{ position: 'relative' }}
                  >
                    {/* <h6 style={{ fontWeight: "bold" }}>Número do Cartão*</h6> */}
                    <input
                      value={this.state.cardNumber}
                      placeholder="Número do cartão*"
                      style={{ paddingLeft: 34 }}
                      onChange={(e) => this.onHandleChange(e, 'cardNumber')}
                      name={'cardNumber'}
                      maxLength={16}
                    ></input>
                    <span
                      className="fa fa-credit-card"
                      style={{
                        fontSize: 20,
                        position: 'absolute',
                        left: 8,
                        bottom: 12,
                      }}
                    ></span>
                  </div>
                  <div className="card-other padding-top-20">
                    <div>
                      {/* <h6 style={{ fontWeight: "bold" }}>Data de Validade*</h6> */}
                      <input
                        value={this.state.card_name}
                        placeholder="Nome impresso no cartão*"
                        onChange={(e) => this.onHandleChange(e, 'card_name')}
                        maxLength={45}
                      ></input>
                    </div>
                    <div>
                      {/* <h6 style={{ fontWeight: "bold" }}>Código de Segurança*</h6> */}
                      <input
                        placeholder="CPF do titular do cartão*"
                        value={this.state.cpf}
                        onChange={(e) => this.onHandleChange(e, 'cpf')}
                        maxLength={14}
                      ></input>
                    </div>
                  </div>
                  <div className="card-other padding-top-20">
                    <div>
                      {/* <h6 style={{ fontWeight: "bold" }}>Data de Validade*</h6> */}
                      <input
                        placeholder="Data de validade*"
                        value={this.state.expireDate}
                        onChange={(e) => this.onHandleChange(e, 'expireDate')}
                        maxLength={5}
                      ></input>
                    </div>
                    <div>
                      {/* <h6 style={{ fontWeight: "bold" }}></h6> */}
                      <input
                        style={{ width: 'calc(100% - 50px)' }}
                        value={this.state.cvvCode}
                        placeholder="Código de segurança*"
                        onChange={(e) => this.onHandleChange(e, 'cvvCode')}
                        maxLength={3}
                      ></input>
                      <span style={{ padding: 10 }}>
                        <OverlayTrigger
                          trigger="click"
                          placement={'left'}
                          overlay={
                            <Popover id={`popover-positioned-left`}>
                              <Popover.Content
                                style={{ padding: 6, fontWeight: 500 }}
                              >
                                <Row>
                                  <Col className="text-center">
                                    <img
                                      style={{ verticalAlign: 'top' }}
                                      src={credit_front}
                                      alt="Credit Card Front"
                                    />
                                    <br />
                                    Frente
                                    <br /> 4 digitos
                                  </Col>
                                  <Col className="text-center">
                                    <span
                                      style={{ fontSize: 20 }}
                                      className="fa fa-credit-card"
                                    ></span>
                                    <br />
                                    Verso
                                    <br /> 3 digitos
                                  </Col>
                                </Row>
                                <Row>
                                  O seu CVV pode estar na frente ou no verso do
                                  seu cartao
                                </Row>
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <span
                            className="fa fa-info-circle"
                            style={{ fontSize: 24, color: 'gray' }}
                          ></span>
                        </OverlayTrigger>
                      </span>
                    </div>
                  </div>
                  <div className="check-button-area padding-top-20">
                    <div
                      className="checkbox"
                      onClick={() =>
                        this.setState({ isAcceptPolicy: !isAcceptPolicy })
                      }
                    >
                      {isAcceptPolicy && <img src={checkicon} />}
                    </div>
                    <label htmlFor="inlineCheckbox1">
                      {' '}
                      Concordo com a política de privacidade, os dados <br />
                      coletados serão utilizados apenas para esta transação.
                    </label>
                  </div>
                  <div className="confirm-button padding-top-5">
                    <button
                      disabled={!this.state.isAcceptPolicy}
                      onClick={() => this.onSubmit()}
                    >
                      <b>Realizar Pagamento</b>
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="sub-footer">
          <div className="total-amount">
            <img src={backet} alt="backet"></img>
            <h5 style={{ margin: 0, paddingLeft: '20px' }}>
              {' '}
              {this.state.totalOrderAmount.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </h5>
          </div>
        </div>
        {isLoading && (
          <div className="loading">
            <div className="loaderImg">
              <img src={gitLoading} alt="loading" />
              <span className="fa fa-lock" style={{ fontSize: 24 }}></span>
            </div>
            <label style={{ textAlign: 'center', marginTop: 30, width: 300 }}>
              Processando pagamento aguarde até ser direcionado a página de
              confirmação.
            </label>
          </div>
        )}
        {this.state.alertType === 'success' ? (
          <SweetAlert
            success
            title={this.state.alertMsg}
            show={this.state.showAlert}
            onConfirm={this.onConfirm}
            onCancel={this.onCancel}
          ></SweetAlert>
        ) : (
          <SweetAlert
            warning
            title={this.state.alertMsg}
            show={this.state.showAlert}
            onConfirm={this.onConfirm}
            onCancel={this.onCancel}
          ></SweetAlert>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cards: state.cards,
    taxes: state.taxes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendCardInfor: (cardData) => dispatch(sendCardInfor(cardData)),
    getAllTaxesCreaSP: (data) => dispatch(getAllTaxesCreaSP(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CardScreen);
